// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateIsInitialLoad = (state, action) => action.isInitialLoad;

export default (state = getDefaultState().isInitialLoad, action) => {

    const actionTypes = {
        [actions.UPDATE_REIMBURSEMENT_SUMMARY_IS_INITIAL_LOAD]: updateIsInitialLoad
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/is-initial-load.js